module.exports = __webpack_public_path__ + "static/media/social-preview-examples.ce8355b1.png";